import DotLegalDeleteDialogWrapper from "../../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { useTranslation } from "../../../localization/useTranslation";
import { FrameworkControlTaskTableRow } from "../frameworkControlOverview/FrameworkControlOverview.types";
import { useDeleteFrameworkControlTaskDialogHooks } from "./DeleteFrameworkControlTaskDialog.hooks";

export interface IDeleteFrameworkControlTaskDialogProps {
    controlId: string;
    selectedControlTask: FrameworkControlTaskTableRow;
    onDialogClose: () => void;
    onDeleted: () => void;
}

function DeleteFrameworkControlTaskDialog(props: IDeleteFrameworkControlTaskDialogProps) {
    const { translateString } = useTranslation();
    const { inProgess, removeControlTask } = useDeleteFrameworkControlTaskDialogHooks(props);

    return (
        <DotLegalDeleteDialogWrapper
            itemForDeletion={props.selectedControlTask.taskName}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={() => removeControlTask()}
            inProgress={inProgess}
            additionalWarning={translateString("deleteControlTaskWarning")}
        />
    );
}

export default DeleteFrameworkControlTaskDialog;
